/**
 * CampaignsApiPage — "Campañas (API)".
 *
 * Reutiliza EXACTAMENTE el tablero de Campañas Digitales, pero alimentado en vivo
 * por las APIs de pauta en lugar de los Excel mensuales. Agrupa las redes
 * publicitarias en una sola pantalla con un selector de red como primer filtro:
 *   - Meta: Marketing API (Ads Insights).
 *   - TikTok: Business/Marketing API de TikTok Ads.
 * No se suman entre sí: alcance y frecuencia no son aditivos entre redes.
 *
 * La red vive en la URL (?red=tiktok) para poder compartir el enlace y para que
 * la ruta antigua /campaigns-tiktok redirija aquí. `key` remonta el tablero al
 * cambiar de red: los meses disponibles cambian y el periodo elegido en una red
 * no tiene por qué existir en la otra.
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import CampaignsPage from '../CampaignsPage/CampaignsPage';

const NETWORKS = [
  { id: 'meta', label: 'Meta' },
  { id: 'tiktok', label: 'TikTok' },
];

export default function CampaignsApiPage() {
  const { user } = useAuthenticator((context) => [context.user]);
  const [params, setParams] = useSearchParams();
  const red = NETWORKS.some((n) => n.id === params.get('red')) ? params.get('red') : 'meta';
  const changeNetwork = (id) => setParams(id === 'meta' ? {} : { red: id }, { replace: true });
  return (
    <CampaignsPage
      key={red}
      source={red}
      username={user?.username}
      networks={NETWORKS}
      onNetworkChange={changeNetwork}
    />
  );
}
